import _toConsumableArray from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "./index.css";
import { jsx as e, jsxs as t } from "react/jsx-runtime";
import { Icon as n } from "@design-system/icon";
import { Section as i } from "@design-system/section";
import { Typography as a } from "@design-system/typography";
import { ScreenRecognitionContext as r } from "@phx-husky/screen-recognition";
import o from "classnames";
import { forwardRef as s, useState as l, useContext as c, useEffect as b } from "react";
var d;
!function (e) {
  e.PAUSE = "pause", e.PLAY = "play", e.NEXT = "next", e.PREVIOUS = "previous";
}(d || (d = {}));
var m = s(function (_ref, h) {
  var s = _ref.className,
    m = _ref.messages,
    u = _ref.ariaLabels,
    _ref$soloMode = _ref.soloMode,
    p = _ref$soloMode === void 0 ? !1 : _ref$soloMode,
    _ref$intervalTime = _ref.intervalTime,
    g = _ref$intervalTime === void 0 ? 4 : _ref$intervalTime;
  var _l = l(0),
    _l2 = _slicedToArray(_l, 2),
    f = _l2[0],
    v = _l2[1],
    _l3 = l(!1),
    _l4 = _slicedToArray(_l3, 2),
    y = _l4[0],
    O = _l4[1],
    _c = c(r),
    k = _c.isMobile,
    j = function j(e) {
      var t = _toConsumableArray(m.keys()),
        n = t[m.length - 1];
      switch (e) {
        case d.PAUSE:
          O(!0);
          break;
        case d.PLAY:
          O(!1);
          break;
        case d.NEXT:
          v(function (e) {
            var n;
            return null !== (n = t[e + 1]) && void 0 !== n ? n : 0;
          });
          break;
        case d.PREVIOUS:
          v(function (e) {
            var i;
            return null !== (i = t[e - 1]) && void 0 !== i ? i : n;
          });
      }
    };
  b(function () {
    if (y || m.length <= 0 || p) return;
    var e = setInterval(function () {
      j(d.NEXT);
    }, 1e3 * g);
    return function () {
      clearInterval(e);
    };
  }, [y]);
  var w = function w() {
      j(d.NEXT);
    },
    E = function E() {
      j(d.PREVIOUS);
    };
  return e(i, Object.assign({
    "data-testid": "info-bar",
    ref: h,
    element: "aside",
    removeAllSpacing: !0,
    className: o("cds-info-bar", s)
  }, {
    children: t("div", Object.assign({
      className: "cds-info-bar__container"
    }, {
      children: [k && !p && e("button", Object.assign({
        type: "button",
        "aria-label": null == u ? void 0 : u.arrowLeft,
        onClick: E
      }, {
        children: e(n, {
          icon: "arrowLeft"
        })
      })), e(a, {
        variant: "body",
        size: k ? "xs" : "s",
        weight: "medium",
        className: "cds-info-bar__message",
        content: m[f].text
      }), k && !p && e("button", Object.assign({
        type: "button",
        "aria-label": null == u ? void 0 : u.arrowRight,
        onClick: w
      }, {
        children: e(n, {
          icon: "arrowRight"
        })
      })), !k && !p && t("div", Object.assign({
        className: "cds-info-bar__action-icons"
      }, {
        children: [e("button", Object.assign({
          type: "button",
          "aria-label": null == u ? void 0 : u.arrowLeft,
          onClick: E
        }, {
          children: e(n, {
            icon: "arrowLeft"
          })
        })), e("button", y ? Object.assign({
          type: "button",
          "aria-label": null == u ? void 0 : u.play,
          onClick: function onClick() {
            j(d.PLAY);
          },
          id: "btn-play"
        }, {
          children: e(n, {
            icon: "play"
          })
        }) : Object.assign({
          type: "button",
          "aria-label": null == u ? void 0 : u.pause,
          onClick: function onClick() {
            j(d.PAUSE);
          }
        }, {
          children: e(n, {
            icon: "pause"
          })
        })), e("button", Object.assign({
          type: "button",
          "aria-label": null == u ? void 0 : u.arrowRight,
          onClick: w
        }, {
          children: e(n, {
            icon: "arrowRight"
          })
        }))]
      }))]
    }))
  }));
});
export { m as InfoBar };